import { combine } from 'react-hooks-combine'

import AthleteViewComponent from './component'

export const AthleteView = combine({
  transformProps: ({ match }) => ({
    athleteId: Number(match.params.athleteId),
  }),
})(AthleteViewComponent)
